module.exports = __webpack_public_path__ + "static/media/triangle-blue.0244a643.svg";